var map = {
	"./TDK_logo.jpeg": 96,
	"./TDK_logo.png": 97,
	"./Thaisurvie_logo.png": 98,
	"./address_image.svg": 99,
	"./bkk_hackathon.png": 100,
	"./blogs_image.svg": 101,
	"./cloud_infrastructure.svg": 102,
	"./contactMail.png": 103,
	"./cu_logo.png": 104,
	"./developerActivity.svg": 105,
	"./education.svg": 106,
	"./experience.svg": 107,
	"./feelingProud.svg": 108,
	"./fullstack.svg": 109,
	"./harvard_logo.png": 110,
	"./lbs_logo.svg": 111,
	"./logo_kmutnb.png": 112,
	"./mmct_logo.svg": 113,
	"./moon.svg": 114,
	"./panasonic_logo.png": 115,
	"./projects_image.svg": 116,
	"./skill.svg": 117,
	"./skilllane_certificate_logo.png": 118,
	"./software_park_logo.png": 119,
	"./sun.svg": 120,
	"./thaisuvive_logo.png": 121,
	"./udemy-logo.svg": 122,
	"./udemy_logo.png": 123,
	"./ui_ux_design.svg": 124,
	"./weprofile-144x144.png": 125,
	"./weprofile-192x192.png": 126,
	"./weprofile-200.png": 127,
	"./weprofile-300-old.png": 128,
	"./weprofile-300.png": 129,
	"./weprofile-36x36.png": 130,
	"./weprofile-400.png": 131,
	"./weprofile-48x48.png": 132,
	"./weprofile-72x72.png": 133,
	"./weprofile-96x96.png": 134,
	"./weprofile-org.png": 135,
	"./weprofile.jpg": 136,
	"./weprofile.png": 137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;